import { authService } from './auth';

export const exportTrainingSamples = async (format: 'json' | 'csv' = 'json') => {
  const session = await authService.getCurrentSession();
  if (!session) {
    throw new Error('No valid session found. Please sign in again.');
  }

  const accessToken = session.getAccessToken().getJwtToken();
  const url = `https://ai.rash-id.com/staging/api/v2/training/export/samples?format=${format}`;

  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Export failed: ${response.status}`);
  }

  if (format === 'csv') {
    return response.blob();
  }
  
  return response.json();
};